import { useEffect, useState } from "react";
import { Luggage, Backpack, Plane, Stamp, HeartPulse, Wallet2 } from "lucide-react";
import api from "../../lib/api";

/* Mini profile for one household member — bags, gear, programs, visa links,
   insurance and wallet items in one compact view. */
export default function TravelerProfile({ travelerId }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get(`/trips/travelers/${travelerId}/profile`).then((r) => setP(r.data)).catch(() => setP(null));
  }, [travelerId]);

  if (!p) return <p className="text-xs text-muted-foreground mt-2">Loading profile…</p>;

  const Section = ({ icon: Icon, title, items, render, testid }) => (
    <div data-testid={testid}>
      <div className="text-[11px] font-700 uppercase tracking-wider text-muted-foreground flex items-center gap-1 mb-0.5">
        <Icon className="w-3 h-3" /> {title} ({items.length})
      </div>
      {items.length === 0
        ? <div className="text-xs text-zinc-400">None assigned</div>
        : <ul className="text-xs space-y-0.5">{items.slice(0, 8).map((it) => <li key={it.id} className="truncate">• {render(it)}</li>)}
          {items.length > 8 && <li className="text-zinc-400">+{items.length - 8} more</li>}</ul>}
    </div>
  );

  return (
    <div className="mt-3 border-t border-zinc-100 pt-2 space-y-2" data-testid={`traveler-profile-${travelerId}`}>
      <Section icon={Luggage} title="Bags" testid={`profile-bags-${travelerId}`}
        items={[...p.bags, ...p.gear_bags]} render={(b) => b.name || "Bag"} />
      <Section icon={Backpack} title="Gear & items" testid={`profile-items-${travelerId}`}
        items={p.gear_items} render={(i) => i.name} />
      <Section icon={Plane} title="Loyalty programs" testid={`profile-programs-${travelerId}`}
        items={p.programs} render={(g) => `${g.program_name || g.airline_name}${g.tier ? ` · ${g.tier}` : ""}${g.balance ? ` · ${Number(g.balance).toLocaleString()} ${g.unit || "miles"}` : ""}`} />
      <Section icon={Stamp} title="Visa / entry links" testid={`profile-visas-${travelerId}`}
        items={p.visa_links} render={(v) => `${v.country} — ${v.title}`} />
      <Section icon={HeartPulse} title="Insurance policies" testid={`profile-insurance-${travelerId}`}
        items={p.insurance} render={(i) => `${i.company}${i.valid_to ? ` · until ${i.valid_to}` : ""}`} />
      <Section icon={Wallet2} title="Wallet benefits" testid={`profile-wallet-${travelerId}`}
        items={p.wallet_items} render={(w) => `${w.title} (${w.kind}${w.status !== "active" ? ` · ${w.status}` : ""})`} />
    </div>
  );
}
